import type { Action } from './types';

const action: Action = {
  action: 'CREATE_CLIENT',
  getHref: attributes => {
    const attrs = attributes as { first_name?: string; last_name?: string; email_address?: string };
    const params = new URLSearchParams({ create: 'true' });
    if (attrs.first_name) params.set('first_name', attrs.first_name);
    if (attrs.last_name) params.set('last_name', attrs.last_name);
    if (attrs.email_address) params.set('email_address', attrs.email_address);
    return `/clients/all?${params}`;
  },
  getFollowUp: attributes => {
    const attrs = attributes as { first_name?: string; last_name?: string };
    const name = formatName(attrs.first_name, attrs.last_name);
    return {
      title: name ? `Create a profile for ${name}` : 'Create a client profile',
      message: name
        ? `Add ${name} to your client list so you can start managing their information.`
        : 'Add this person to your client list so you can start managing their information.',
    };
  },
  completionEvents: ['CLIENT_CREATED'],
};

export default action;

function formatName(firstName?: string, lastName?: string): string {
  return [firstName, lastName].filter(Boolean).join(' ');
}
